<template>
  <router-view :key="routeId"></router-view>
</template>
<script>
  export default {
    data () {
      return {
        routeId: 0
      }
    },
    watch: {
      '$route.params.id' (newval, oldval) {
        this.routeId = newval || 0
      }
    }
  }
</script>
